"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ValidationMultiError_1 = require("../errors/ValidationMultiError");
const noError_1 = require("../helpers/noError");
const validationMultiError = (errors, key) => {
    const error = {
        type: ValidationMultiError_1.ValidationMultiErrorType,
        key: key,
        errors: errors,
    };
    return {
        error: error,
    };
};
exports.chainValidators = (value, key, ...validators) => {
    const errors = validators
        .map(func => func(value, key))
        .map(q => q.error)
        .filter(q => q !== undefined);
    if (errors.length === 1) {
        return {
            error: errors[0],
        };
    }
    if (errors.length > 1) {
        return validationMultiError(errors, key);
    }
    return noError_1.noError();
};
//# sourceMappingURL=chainValidators.js.map